'use strict';

import TranslationStore from '../stores/TranslationStore';

function changeLanguage(newLang) {
  // make sure we're actually requesting a change
  let oldLang = TranslationStore.getCurrentLanguage();
  if (oldLang === newLang) return;

  let langPref = window.langPref;
  let url = window.location.href;
  let regex = new RegExp(langPref);

  if (regex.test(url)) {
    url = url.replace(langPref, newLang);
  } else if (/\?/.test(url)) {
    url = url + `&langPref=${langPref}`;
  } else {
    url = url + `?langPref=${langPref}`;
  }

  window.location.replace(url);

  // make sure it's a supported language
  // TranslationStore.getAvailableLanguages().forEach((language, i) => {
  //   if (language.code === newLang) {
  //     fetch('/translations/' + newLang + '.json')
  //       .then(response => response.json())
  //       .then(function (json) {
  //         TranslationStore.setLanguage(newLang, json);
  //       });
  //   }
  // });
}

export default {
  changeLanguage: changeLanguage
};



// WEBPACK FOOTER //
// ./client/src/actions/language.js